import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';

const GetRateSchedules = {
  name: 'getRateSchedules',
  state: {
    data: [],
    loading: false,
    error: '',
    totalCount: 0,
    tableHeader: [
      'Rate Schedule Name',
      'Playlist Time',
      'Number of Zones',
      'Displays'
    ],
    rpp: 10,
  },
  reducers: {
    getRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        data: [],
        totalCount: 0,
      };
    },

    getReceived(state, payload) {
      const rateScheduleData = payload.data.map(item => ({
        id: item.id,
        name: item.name,
        playlistTime: item.totalPlaylistTime,
        noOfZones: item.noOfZones,
        displays:item.noOfDisplays
      }));

      return {
        ...state,
        data: rateScheduleData,
        loading: false,
        error: '',
        totalCount: payload.totalCount,
      };
    },

    getRequestFailed(state, payload) {
      return {
        ...state,
        error: payload,
      };
    },
  },
  effects: (dispatch) => ({
    async getAll({ page, size, search, sorted_by, sort }) {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        let url = `savvy/rate-schedule?org_id=${userInfo.org_id}&page=${page}&size=${size}`;
        if (search) {
          url = url + `&search=${encodeURIComponent(search)}`;
        }
        if (sorted_by) {
          url = url + `&sorted_by=${sorted_by}`;
        }
        if (sort) {
          url = url + `&sort=${sort}`;
        }

        const response = await http.get(url);
        this.getReceived({
          data: response.data.data.rows,
          totalCount: response.data.data.count,
        });
      } catch (err) {
        this.getRequestFailed(err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
      }
    },
  }),
};

export default GetRateSchedules;
